import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { AGENT_NAV } from "@/lib/agent-nav";
import { MessageInbox } from "@/components/messaging/MessageInbox";

export const Route = createFileRoute("/agent/messages")({
  head: () => ({
    meta: [
      { title: "Messages — Strategist Portal" },
      { name: "description", content: "Secure messaging with your assigned households." },
      { property: "og:title", content: "Messages — Strategist Portal" },
      { property: "og:description", content: "Secure messaging with your assigned households." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => (
    <ProtectedRoute requiredRole="agent">
      <PortalShell title="Strategist Portal" nav={AGENT_NAV} tourKey="agent_tour">
        <MessageInbox scope="agent" />
      </PortalShell>
    </ProtectedRoute>
  ),
});
